import { platformStatsSchema, platformTotalsSchema } from "../schemas/platform-stats";
import { fetchApi } from "./internal";

export const platformStats = {
	/** Lightweight lifetime totals for sidebar navigation. */
	counts: () => fetchApi("/admin/counts", platformTotalsSchema),
	/** Dashboard overview: lifetime totals + a daily growth series over `days`. */
	get: (days?: number) =>
		fetchApi(`/admin/stats${days ? `?days=${days}` : ""}`, platformStatsSchema),
};
